import ProjectComponent from "../components/ProjectComponent";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const ProjectsContainer = ({ slice = null }) => {
    const [projects, setProjects] = useState([]);
    const navigate = useNavigate();

    console.log("fe", process.env.REACT_APP_PROJECTS_URL)

    useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data } = await axios.get(process.env.REACT_APP_PROJECTS_URL);
        setProjects(data);
      } catch (err) {
        console.error("Failed to load projects:", err);
      }
    };

    fetchProjects();
  }, []);

    let projectsDisplay = projects;
    if(slice != null) projectsDisplay = projects.slice(0, parseInt(slice));

    return (
        <div className="bg-primary h-full pb-[100px] ">
            {
                projectsDisplay.map((p, index) => <ProjectComponent
                    project={p}
                    isLastOnPage={projectsDisplay.length == index + 1}
                    isReverse={index % 2 != 0}
                />)
            }
            {
                slice != null &&
                <div className=" view-all" onClick={() => { navigate("/portfolio") }}>
                    View All
                </div>
            }

        </div>
    );
}

export default ProjectsContainer;